import { call, put, takeLatest } from 'redux-saga/effects';
import { getVirtuosoPromotionsRequest, getVirtuosoPromotionsSuccess } from '../../slices/cruise';
import axios from '../axiosConfig';

function* getVirtuosoPromotionsWorker(action) {
  try {
    const config = {
      method: 'get',
      url: `cruises/getVirtuosoPromotions?id=${action.payload}`,
    };
    const response = yield call(axios, config);
    if (response.data && response.data.promotions) {
      yield put(getVirtuosoPromotionsSuccess({ data: response.data }));
    } else throw new Error();
  } catch {
    // The endpoint 404s when the integration is off or Virtuoso has no detail for the
    // sailing; the modal falls back to linking out to virtuoso.com.
    yield put(
      getVirtuosoPromotionsSuccess({ error: 'Could not retrieve Virtuoso promotion details' }),
    );
  }
}

function* getVirtuosoPromotionsWatcher() {
  yield takeLatest(getVirtuosoPromotionsRequest.toString(), getVirtuosoPromotionsWorker);
}

export default getVirtuosoPromotionsWatcher;
